import React from 'react'
import LinearProgress from 'material-ui/LinearProgress'

const LinearLoader = () => (
  <div style={{ margin: 20 }}>
    <LinearProgress mode="indeterminate" />
  </div>
)

export default LinearLoader



// WEBPACK FOOTER //
// ./src/common/LinearLoader.js